import { createSlice } from "@reduxjs/toolkit";

export const slaplanSlice = createSlice({
  name: "slaplan",
  initialState: {
    getSlaplanResult: false,
    getSlaplanLoading: false,
    getSlaplanError: false,
    addSlaplanResult: false,
    addSlaplanLoading: false,
    deleteSlaplanResult: false,
  },
  reducers: {
    slaplanReducers: (state, action) => {
      const { type, payload } = action.payload;
      switch (type) {
        case "GET_SLAPLAN":
          return {
            ...state,
            getSlaplanResult: payload.data,
            getSlaplanLoading: payload.loading,
            getSlaplanError: payload.error,
          };
        case "ADD_SLAPLAN":
          return {
            ...state,
            addSlaplanResult: payload.data,
            addSlaplanLoading: payload.loading,
          };
        case "DELETE_SLAPLAN":
          return {
            ...state,
            deleteSlaplanResult: payload.data,
          };
        default:
          return state;
      }
    },
  },
});

export const { slaplanReducers } = slaplanSlice.actions;

export default slaplanSlice.reducer;
